import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";
import global from './global/index';
import user from './user/index';
import menu from './menu/index';
import wallet from './wallet/index';
import tutorial from "./tutorials/index";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    profile,
    global,
    user,
    menu,
    wallet,
    tutorial
  }
});
